export default function isObject(obj) {
  if (Array.isArray(obj)) {
    return false;
  }
  return typeof obj === 'object' && obj !== null;
}
